import {SearchKeyAllFields} from "@hooks/query/types/queryParams";

export const DEFAULT_PER_PAGE = 20


export const DEFAULT_DATA_SELECT_PER_PAGE: {
	value: string,
	label: string
} [] = [
	{value: '5', label: '5'},
	{value: '10', label: '10'},
	{value: '20', label: '20'},
	{value: '25', label: '25'},
	{value: '50', label: '50'},
	{value: '100', label: '100'}];

export const SEARCH_KEY_ALL_SEARCH_FIELDS: SearchKeyAllFields = 'ALL_SEARCH_FIELDS'